<template>
    <div>
        <!-- 签约地址  -->
        <el-dialog title="签约地址" :visible.sync="addVisible" :close-on-click-modal="false" width="600px" center>
            <el-table :data="SignListData" border style="width: 100%" class="table">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column prop="name" label="名称" width="100px"></el-table-column>
                <el-table-column prop="tel" label="电话" width="100px"></el-table-column>
                <el-table-column prop="url" label="签约地址">
                  <template slot-scope="scope">
                    <a href="javascript:;" @click="signAddress(scope.row)">{{scope.row.url}}</a>
                  </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import contractprocedure from '@/script/api/contractapi';
export default {
    data() {
        return {
            addVisible: false,
            SignListData: [],
            procedureId: ''
        };
    },
    methods: {
      signAddress(row) {
        console.log(row);
        window.open(row.url);
      },
        signAdressDiaRow(row) {
            console.log(row);
            this.SignListData = [];
            this.addVisible = true;
            this.procedureId = row.procedure_id;
            console.log(this.procedureId );
            if (this.procedureId == null || this.procedureId == '' || this.procedureId == undefined) {
                this.procedureId = row.processId;
            }
            this.getSignAddrData();
        },
        getSignAddrData() {
            contractprocedure
                .$ajaxselectContractSignUrl({ procedureId: this.procedureId })
                .then((res) => {
                    console.log(res);
                    if (res.data.errno == 0) {
                        this.SignListData = res.data.data;
                    } else {
                        this.$message.warning(res.data.data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }
};
</script>
<style lang="">
</style>
